module.exports = __webpack_public_path__ + "img/AccountBalances.0ead05f9.png";